var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExploreMobileForYou(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Explore",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/iconStars"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.12487,8.2497403 L16.1678585,6.16779556 L18.2499291,5.12487015 L16.1678585,4.08194474 L15.12487,2 L14.0818815,4.08194474 L11.9998109,5.12487015 L14.0818815,6.16779556 L15.12487,8.2497403 Z M20.7499764,9.49968835 L20.1249645,8.2497403 L19.4999527,9.49968835 L18.2499291,10.1246624 L19.4999527,10.7496364 L20.1249645,11.9995845 L20.7499764,10.7496364 L22,10.1246624 L20.7499764,9.49968835 Z M16.2303597,12.4409724 L12.1365322,11.843341 L10.3044664,8.12474549 C9.97633515,7.46071058 9.02709845,7.45289841 8.69506092,8.12474549 L6.86299503,11.843341 L2.76916762,12.4409724 C2.03477874,12.5464367 1.73789812,13.4526491 2.27306449,13.9721588 L5.23796431,16.8626636 L4.53482601,20.9484314 C4.40982365,21.6866819 5.1871821,22.2413464 5.83563186,21.8937046 L9.49976364,19.9640973 L13.1638954,21.8937046 C13.8162515,22.2374403 14.5897036,21.6866819 14.4647013,20.9484314 L13.7654693,16.8626636 L16.7303691,13.9721588 C17.2616292,13.4526491 16.9647485,12.5464367 16.2303597,12.4409724 Z",
    id: "stars",
    fill: "#858199",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExploreMobileForYou);
export default __webpack_public_path__ + "static/media/iconExploreMobileForYou.19fd3b96.svg";
export { ForwardRef as ReactComponent };